import { useEffect, useState } from 'react';
import { Grid2 as Grid, Avatar, Typography, Stack, Dialog, DialogTitle, IconButton, DialogContent, useMediaQuery, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { blue } from '@mui/material/colors';
import { Close} from '@mui/icons-material';
import DatasetIcon from '@mui/icons-material/Dataset';

import {DataGroupByItem} from './DataGroupByItem';

interface GroupByTableProps {
  isGroupByDialogOpen: boolean;
  closeGroupByDialog: () => void;
  rows?: DataGroupByItem[];
  title?: string;
}

const DataGroupByTable = (props: GroupByTableProps): JSX.Element => {

    const theme = useTheme();

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
      });

    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (props.rows?.length === 0) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }
    },[props.rows]);

    return (
                <Dialog
                    open={props.isGroupByDialogOpen}
                    scroll={'paper'}
                    fullScreen={fullScreen}
                    fullWidth={true}
                    maxWidth={'md'}
                    keepMounted
                    onClose={props.closeGroupByDialog}
                    sx={{
                        "& .MuiDialog-container": {
                            justifyContent: "flex-end",
                            alignItems: "flex-end"
                        }
                    }}
                    PaperProps={{
                        sx: {
                            m: 0,
                            top: 0,
                            right: 0,
                            bottom: 0,
                            minHeight: isMd? '100vh': '90vh'
                        }
                    }}
                >
                    <DialogTitle>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Avatar sx={{ bgcolor: blue[500] }}><DatasetIcon /></Avatar>
                            <Typography variant="subtitle1" sx={{ color: blue[800] }}>
                                {props.title}
                            </Typography>
                        </Stack>
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={props.closeGroupByDialog}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <Close />
                    </IconButton>
                    <DialogContent dividers>
                        <Grid container spacing={1} justifyContent="center" alignItems="center">
                            <TableContainer sx={{ width: isMd?'80%': '100%' }}>
                                <Table aria-label="group by table" size="small">
                                <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Typography
                                            variant={'subtitle2'}
                                            fontWeight={600}>
                                        Count
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            variant={'subtitle2'}
                                            fontWeight={600}>
                                        Group
                                        </Typography>
                                    </TableCell>
                                    <TableCell align='right'>
                                        <Typography
                                            variant={'subtitle2'}
                                            fontWeight={600}>
                                        Total
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                </TableHead>
                                    <TableBody>
                                    {props.rows?.map((group,index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Typography variant={'subtitle2'}>
                                                {group.count}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant={'subtitle2'}>
                                                {group.description} 
                                            </Typography>
                                        </TableCell>
                                        <TableCell align='right'>
                                            <Typography variant={'subtitle2'}>
                                                {group.totalDisplay}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>     
                        </Grid>              
                    </DialogContent>
                     {/*loading indicator*/}
                           <CircularProgress
                                aria-label='Loading'
                                size={50}
                                className={isLoading? "": "hidden"}
                                sx={{
                                  position: "fixed",
                                  left: "65%",
                                  top: "20%",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: 2
                                 }}
                            />
                </Dialog>
        );
    };

export default DataGroupByTable;